import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSunMoonGlyphSecondary from './svgs/SunMoonGlyphSecondary.js';
import SvgSunMoonGlyph from './svgs/SunMoonGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sunMoonGlyph = (props => useIcon(SvgSunMoonGlyph, SvgSunMoonGlyphSecondary, props));

export { sunMoonGlyph as default };
